import { Box, Button, Flex, HStack } from "@chakra-ui/react";
import { IoIosAdd } from "react-icons/io";
import projectConstants from "../../../constants/ProjectConstants";
import { t } from "i18next";

const MAX_OPTIONS = projectConstants.MAX_OPTIONS_PER_PROJECT;

export default function PartSkeleton() {
  return (
    <HStack className='w-full m-2'>
      <Box className='w-2/3'>
        <p className='w-32 text-lg my-5'>{t("building.buttons")}</p>
        <div className='flex flex-col gap-4'>
          {Array(MAX_OPTIONS)
            .fill({})
            .map((_, index) => {
              return (
                <Button
                  key={index}
                  background='transparent'
                  border='2px dashed #00bcee'
                  disabled={true}
                  opacity={0.4}
                  _hover={{
                    opacity: "0.4",
                    cursor: "default",
                  }}
                  width='500px'
                  height='10'
                  color='#00bcee'
                  rounded={"full"}
                  fontWeight={"light"}
                  className='flex items-center gap-2'
                >
                  <IoIosAdd className='text-3xl' />
                </Button>
              );
            })}
        </div>
      </Box>
      <Box className='w-1/3'>
        <Flex className='w-full' justify={"center"}>
          <Flex
            bg='#323232'
            border='3px solid #00C0F3'
            w='210px'
            h='366px'
            rounded='40px'
            align='center'
            position='relative'
            justifyContent={"center"}
          >
            <HStack
              justify='center'
              align='center'
              padding='10px'
              w='100%'
              dir='ltr'
            >
              <p className='text-white'>{t("selectToPreview")}</p>
            </HStack>
          </Flex>
        </Flex>
      </Box>
    </HStack>
  );
}
